import React, { createContext, useContext } from 'react';
import useGcpConfigHook from '../../../hooks/Dashboard/gcp/useConfig';

export const GcpConfigContext = createContext();

export const GcpConfigProvider = ({ children }) => {
  const data = useGcpConfigHook(); // Import everything from the hook

  return (
    <GcpConfigContext.Provider value={data}>
      {children}
    </GcpConfigContext.Provider>
  );
};

export const useGcpConfig = () => useContext(GcpConfigContext);